import InfoTooltip from "../../../shared/components/InfoTooltip";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import type { AuthUser } from "../../auth/shared/types/auth";

type ChallengeVisibility = "official" | "organizer";

type AdminCreateChallengeOrganizationFieldsProps = {
  includeInRanking: boolean;
  isAdmin: boolean;
  isTournamentMode: boolean;
  organizerUserId: string;
  organizerUsers: AuthUser[];
  setIncludeInRanking: (value: boolean) => void;
  setOrganizerUserId: (value: string) => void;
  setVisibility: (value: ChallengeVisibility) => void;
  usersLoading: boolean;
  visibility: ChallengeVisibility;
};

export default function AdminCreateChallengeOrganizationFields({
  includeInRanking,
  isAdmin,
  isTournamentMode,
  organizerUserId,
  organizerUsers,
  setIncludeInRanking,
  setOrganizerUserId,
  setVisibility,
  usersLoading,
  visibility,
}: AdminCreateChallengeOrganizationFieldsProps) {
  const createTexts = siteTexts.admin.createChallengePage;
  const info = siteTexts.common.info;
  const isOrganizerEvent = !isAdmin || visibility === "organizer";

  return (
    <>
      {isAdmin ? (
        <div className="admin-row-two">
          <label className="field">
            <span className="info-label">
              {createTexts.organization}
              <InfoTooltip content={info.userRole} />
            </span>
            <select
              value={visibility}
              onChange={(event) => {
                const next = event.target.value as ChallengeVisibility;
                setVisibility(next);
                if (next === "official") {
                  setOrganizerUserId("");
                }
              }}
            >
              <option value="official">{createTexts.official}</option>
              <option value="organizer">{createTexts.organizer}</option>
            </select>
          </label>
          <label className="field">
            <span className="info-label">
              {createTexts.organizer}
              <InfoTooltip content={info.users} />
            </span>
            <select
              value={organizerUserId}
              onChange={(event) => setOrganizerUserId(event.target.value)}
              disabled={visibility === "official" || usersLoading}
            >
              <option value="">
                {visibility === "official"
                  ? createTexts.emptyOption
                  : createTexts.currentAdmin}
              </option>
              {organizerUsers.map((user) => (
                <option
                  key={`organizer-create-page-${user.id}`}
                  value={String(user.id)}
                >
                  {user.name}
                </option>
              ))}
            </select>
          </label>
        </div>
      ) : null}

      {(!isTournamentMode || isAdmin) && (
        <label className="field">
          <span className="info-label">
            {isOrganizerEvent
              ? createTexts.includeOrganizerRanking
              : isTournamentMode
              ? createTexts.includeOfficialRanking
              : createTexts.includeRanking}
            <InfoTooltip
              content={isOrganizerEvent ? info.organizerRanking : info.ranking}
            />
          </span>
          <select
            value={includeInRanking ? "yes" : "no"}
            onChange={(event) => setIncludeInRanking(event.target.value === "yes")}
          >
            <option value="yes">{createTexts.yes}</option>
            <option value="no">{createTexts.no}</option>
          </select>
        </label>
      )}
    </>
  );
}
